import {Line} from 'rc-progress';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import Sortable from 'react-anything-sortable';

import ObjectsAPI from '../../api/Objects';
import SortablePhoto from './SortablePhoto';
import * as ApiConst from '../../constants/Api';
import * as ImageUtils from '../../utils/Image';
import * as ImageConst from '../../constants/Image';
import {addImages, deleteImage, updatePhotoOrders, updateMainPhotoURL} from '../../actions/CreatingObjectPage';

import 'react-anything-sortable/sortable.css';

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updatePhotoOrders: images => {
    },
    addImages: (objectId, images) => {
    },
    deleteImage: (objectId, imageId) => {
    },
    updateMainPhotoURL: mainPhotoURL => {
    }
};

class Photo extends Component {
    state = {
        isShowConfirmDeleteImageModal: false
    };

    componentWillReceiveProps(nextProps) {
        const {images, mainPhotoURL} = this.props;
        const newImages = nextProps.images;

        if (
            mainPhotoURL.length === 0 &&
            newImages !== null &&
            newImages.length > 0
        ) {
            let image = newImages[0];
            newImages.forEach(elem => {
                if (elem.order < image.order) image = elem;
            });
            this.props.updateMainPhotoURL(`${ApiConst.BASE_IMG_URL}/${image.id}/thumbs`);
        } else if (newImages === null || newImages.length === 0) {
            this.props.updateMainPhotoURL('');
        } else if (images[0].id !== newImages[0].id) {
            this.props.updateMainPhotoURL(`${ApiConst.BASE_IMG_URL}/${newImages[0].id}/thumbs`);
        }
    }

    handleChange(event) {
        this.props.addImages(this.props.createdObject.id, event.target.files);
    }

    handleSort(sortedArray) {
        let commandImages = [];

        sortedArray.forEach((elem, index) => {
            let commandImage = {
                id: elem.id,
                order: index
            };
            commandImages.push(commandImage);
        });

        const imagesUpdateCommand = {
            images: commandImages
        };

        // Делаем удобный мапинг и делаем клонов
        let map = this.props.createdObject.meta.images.reduce((acc, cur) => {
            acc[cur.id] = Object.assign({}, cur);
            return acc;
        }, {});

        this.props.updatePhotoOrders(sortedArray.map((e, i) => {
            let t = map[e.id];
            t.order = i;
            return t;
        }));

        ObjectsAPI.updateImages(this.props.createdObject.id, imagesUpdateCommand);
    }

    getPhoto() {
        const {images} = this.props;
        let photo = [];

        if (images !== undefined && images !== null && images.length > 0) {

            images.forEach(item =>
                photo.push(
                    <SortablePhoto
                        image={item}
                        key={item.id}
                        sortData={item}
                        deleteImage={this.deleteImage}
                        src={ImageUtils.getSrc(item.id, ImageConst.TYPE.THUMBS)}
                    />
                )
            );
        }
        return photo;
    }

    getProgressBarPercent = () => {
        const {loaded, total} = this.props;

        return Math.round((loaded / total) * 100);
    };

    deleteImage = (objectId, imageId, imageName) => {
        this.setState({
            imageId: imageId,
            objectId: objectId,
            imageName: imageName,
            isShowConfirmDeleteImageModal: true
        });
    };

    handleDeleteImage = () => {
        const {objectId, imageId} = this.state;
        const {deleteImage} = this.props;

        deleteImage(objectId, imageId);

        this.setState({
            isShowConfirmDeleteImageModal: false
        });
    };

    handleCloseDeleteModal = () => {
        this.setState({
            isShowConfirmDeleteImageModal: false
        })
    };

    render() {
        const {isShowConfirmDeleteImageModal, imageName} = this.state;
        const {i18n, isActive, isShowProgressBar} = this.props;

        return (
            <div
                className={isActive ?
                    'clearfix tab_content animated show active' :
                    'clearfix tab_content animated show'}
            >
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.photo']}
                    </h3>
                </div>

                <div className="lead_text">
                    <p>
                        {i18n['creatingObjectPage.photo.hint1']}
                    </p>
                </div>

                <label className="file_label light">
                    {i18n['creatingObjectPage.selectFilesToUpload']}
                    <input type="file" onChange={::this.handleChange} multiple accept=".jpeg,.jpg" />
                </label>

                {isShowProgressBar &&
                <Line percent={this.getProgressBarPercent()} strokeWidth="1" strokeColor="#FC698E" />}

                <div className="clearfix mt30">
                    <div className="grid grid-width-1-3 responsive">
                        <Sortable dynamic onSort={::this.handleSort}>
                            {this.getPhoto()}
                        </Sortable>
                    </div>
                </div>

                <ReactModal
                    className="custom-react-modal"
                    isOpen={isShowConfirmDeleteImageModal}
                    overlayClassName="custom-react-modal-overlay"
                >
                    {`${i18n['creatingObjectPage.photo.confirmDeleteImage']} ${imageName}?`}
                    <br /><br />
                    <button onClick={this.handleDeleteImage} className="btn">
                        {i18n['creatingObjectPage.photo.delete']}
                    </button>
                    <button onClick={this.handleCloseDeleteModal} className="btn">
                        {i18n['creatingObjectPage.photo.cancel']}
                    </button>
                </ReactModal>
            </div>
        )
    }
}

Photo.propTypes = propTypes;
Photo.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    mainPhotoURL: state.creatingObjectPage.mainPhotoURL,
    createdObject: state.creatingObjectPage.createdObject,
    total: state.creatingObjectPage.progressBarInfo.total,
    loaded: state.creatingObjectPage.progressBarInfo.loaded,
    images: state.creatingObjectPage.createdObject.meta.images,
    isShowProgressBar: state.creatingObjectPage.isShowProgressBar
});

const mapDispatchToProps = {
    addImages,
    deleteImage,
    updatePhotoOrders,
    updateMainPhotoURL
};

export default connect(mapStateToProps, mapDispatchToProps)(Photo);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Photo.js